import { RouteName } from '@/constants/routes.constants';
import { useGlobalState } from '@/hooks';
import { getPmtLangHref } from '@/utils';
import Image from 'next/image';
import Link from 'next/link';
import type React from 'react';
import { useState } from 'react';
import {
  FirstLetter,
  ProfileDefaultImage,
  ProfileIconWrapper,
  ProfileImage,
  ProfileName,
  ProfileWrapper,
} from './Profile.styles';

const DefaultProfileImage = ({
  firstName,
  email,
}: {
  firstName?: string;
  email?: string;
}) => {
  if (!firstName && !email) return null;
  const letters = firstName || email;
  return (
    <ProfileDefaultImage>
      <FirstLetter>{letters?.slice(0, 1)}</FirstLetter>
    </ProfileDefaultImage>
  );
};

const GuestProfileImage = () => {
  return (
    <ProfileImage>
      <Image src='/images/icons/person.svg' alt='Profile' width={20} height={20} />
    </ProfileImage>
  );
};

const UserAvatar = ({
  imageUrl,
  firstName,
  email,
}: {
  imageUrl?: string | null;
  firstName?: string;
  email?: string;
}) => {
  const [isImageBroken, setIsImageBroken] = useState(false);

  if (imageUrl && !isImageBroken) {
    return (
      <ProfileImage>
        <Image
          fill
          alt='avatar'
          sizes='100vw'
          style={{
            objectFit: 'cover',
          }}
          src={imageUrl}
          onError={() => setIsImageBroken(true)}
        />
      </ProfileImage>
    );
  }

  return <DefaultProfileImage firstName={firstName} email={email} />;
};

const Profile: React.FC = () => {
  const { isTrackingPage, isLoggedIn, userInfo, isMultiLanguagePage, pmtCurrentLanguageCode } = useGlobalState();

  if (isTrackingPage) return null;

  if (isLoggedIn) {
    return (
      <Link
        // TODO: Update getPmtLangHref name
        href={getPmtLangHref(pmtCurrentLanguageCode, {
          defaultLang: RouteName.AccountEn,
          multiLang: RouteName.AccountMultiLanguages,
        })}
      >
        <ProfileWrapper>
          <UserAvatar imageUrl={userInfo?.profilePictureUrl} firstName={userInfo?.firstName} email={userInfo?.email} />
          {!isMultiLanguagePage && <ProfileName>{userInfo?.firstName}</ProfileName>}
        </ProfileWrapper>
      </Link>
    );
  }

  return (
    <Link
      // TODO: Update getPmtLangHref name
      href={getPmtLangHref(pmtCurrentLanguageCode, {
        defaultLang: RouteName.AccountEn,
        multiLang: RouteName.AccountMultiLanguages,
      })}
    >
      <ProfileIconWrapper>
        <GuestProfileImage />
      </ProfileIconWrapper>
    </Link>
  );
};

export default Profile;
